module.exports = "$(document).ready(function() {\n    // Site.run();\n  });\n"


//////////////////
// WEBPACK FOOTER
// /app/~/raw-loader!/app/~/source-map-loader!/app/src/assets/evs/js/main.js
// module id = ../../../../raw-loader/index.js!../../../../source-map-loader/index.js!../../../../../src/assets/evs/js/main.js
// module chunks = 6